import React, { useEffect, useState } from 'react';
import useAllPurposeConfigsFromTenant from '../../../hooks/useAllPurposeConfigsFromTenant';
import RadioButtonBox from './RadioButtonbox';
import RadioLoadingBoxes from '../../RadioLoadingBoxes/RadioLoadingBoxes';

export default function RadioBoxContainer({
  tenantId,
  setCheck,
  checked,
  check,
  setChecked,
  radioChecked,
  purposeFromTransfer,
}) {
  const res = useAllPurposeConfigsFromTenant(tenantId);

  const jsonData = JSON.parse(JSON.stringify(res));
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (jsonData && jsonData?.purposeConfigs && !data2?.length) {
      if (
        jsonData?.purposeConfigs[0]?.config &&
        jsonData?.purposeConfigs[0]?.config !== '[]'
      ) {
        setLoading(true);
        let a = JSON.parse(jsonData.purposeConfigs[0].config);
        const dta = a?.map((elem, index) => {
          elem.id = index;
          elem.label = elem.purpose;
          return elem;
        });
        setData2(dta);
        setLoading(false);
      }
    }
  }, [jsonData]);

  let selectedPurposeOption = undefined;

  useEffect(() => {
    if (data2) {
      if (data2.length) {
        setChecked(data2[0].id);
      }
    } else {
      setChecked(0);
    }
  }, [data2]);

  // const [checked, setChecked] = useState(
  //   data2 && data2.length > 0 ? data2[0].id : 0,
  // );
  // const [check, setCheck] = useState(false);
  if (purposeFromTransfer && data2 && data2.length > 0 && !check) {
    selectedPurposeOption = data2.find(
      (option) => option.purpose === purposeFromTransfer,
    );
  }
  useEffect(() => {
    if (selectedPurposeOption && selectedPurposeOption.id !== checked) {
      setChecked(selectedPurposeOption.id);
    }
  }, [selectedPurposeOption]);
  useEffect(() => {
    let dataToSend = data2?.find((element) => element.id === checked);
    radioChecked(dataToSend);
  }, [checked, check]);

  useEffect(() => {
    let dataToSend = data2?.find((element) => element.id === checked);
    radioChecked(dataToSend);
  }, [data2]);

  useEffect(() => {
    let dataToSend = data2?.find((element) => element.id === checked);
    radioChecked(dataToSend);
  }, []);

  const setCheckedFunction = (val) => {
    selectedPurposeOption = val;
    setChecked(val);
    setCheck(true);
  };

  if (loading) {
    return <RadioLoadingBoxes />;
  }

  return (
    <div
      className="radio-box-container"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: '1.51041666667vw',
        marginBottom: '3.75vw',
      }}
    >
      {data2?.map((el, index) => {
        if (el.active) {
          return (
            <RadioButtonBox
              key={el.purpose + index}
              content={el}
              onChange={(val) => setCheckedFunction(val)}
              checked={checked}
            />
          );
        }
      })}
    </div>
  );
}
